<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import GenericForm from '@maison/components/form/GenericForm';

export default {
  components: {
    GenericForm,
  },

  mixins: [modalMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    onSuccess() {
      if (!this.formData.form.replaceFormOnSuccess) {
        this.close();
      }
    },
  },
};
</script>

<template>
  <modal :id="id" data-cy="modal-container" :title="title" large>
    <template #content>
      <generic-form
        v-bind="formData"
        :show-errors-in-toast="false"
        :should-reset-form-on-submit="true"
        @on-success="onSuccess"
      />
    </template>
  </modal>
</template>
